import React, { useEffect } from "react";

export function useSource() {
  const ref = React.useRef();
  if (!ref.current) {
    ref.current = { SOURCE: {} };
  } else {
    ref.current.SOURCE = {};
  }
  return ref.current.SOURCE;
}

export const usePrevious = (value) => {
  const ref = React.useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};

// Kendo overlay containers (dropdown lists, popups, calendars, tooltips) are
// portaled to document.body, so clicks inside them are not descendants of the
// popup's wrapper div. Treat any click landing in one of these as "inside".
const KENDO_OVERLAY_SELECTOR =
  ".k-animation-container,.k-popup,.k-list,.k-list-container,.k-calendar-container,.k-tooltip";

export function useDocumentClickEventListener(isAddNewConfig, setNewConfig, divRef) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleDocumentClick = (e) => {
    if (!divRef.current) return;
    //  (e.g. a Kendo
    // dropdown item removed on selection) still resolve correctly.
    const path = typeof e.composedPath === "function" ? e.composedPath() : null;

    const clickedInsideRef = path
      ? path.includes(divRef.current)
      : divRef.current.contains(e.target);
    if (clickedInsideRef) return;

    if (path) {
      for (const node of path) {
        if (
          node &&
          node.nodeType === 1 &&
          typeof node.matches === "function" &&
          node.matches(KENDO_OVERLAY_SELECTOR)
        ) {
          return;
        }
      }
    } else if (e.target && typeof e.target.closest === "function") {
      if (e.target.closest(KENDO_OVERLAY_SELECTOR)) return;
    }

    setNewConfig(false);
  };
  useEffect(() => {
    if (isAddNewConfig) {
      document.body.addEventListener("click", handleDocumentClick);
    } else {
      document.body.removeEventListener("click", handleDocumentClick);
    }

    return () => {
      document.body.removeEventListener("click", handleDocumentClick);
    };
  }, [isAddNewConfig, handleDocumentClick]);
}
